import styled from "styled-components";

export const Button = styled.button`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: white;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius};
`;
